import React from 'react'
import { ExternalLink } from 'lucide-react'
import { StatusBar, StaleBanner } from '../status'

/*
 * Fenster lösen (Multimonitor): Eine große Ansicht öffnet sich in einem eigenen Browserfenster unter /fenster/<ansicht>,
 * ohne Rail, Dock und Navigation. Die Anmeldung gilt weiter (Token liegt in localStorage, gleicher Ursprung).
 * Der Knopf erscheint nur am PC (data-ui="wall", per CSS), auf Touchgeräten nicht.
 */

export const FENSTER_PFAD = '/fenster/'

export function istFenster(): boolean {
  return typeof window !== 'undefined' && window.location.pathname.startsWith(FENSTER_PFAD)
}

export function oeffneFenster(ansicht: string) {
  const b = Math.min(1600, Math.max(900, Math.round(window.screen.availWidth * 0.8)))
  const h = Math.min(1000, Math.max(600, Math.round(window.screen.availHeight * 0.8)))
  // Gleicher Name: dieselbe Ansicht öffnet nicht doppelt, sondern holt das vorhandene Fenster nach vorn
  const w = window.open(`${FENSTER_PFAD}${encodeURIComponent(ansicht)}`, `pilot-hub-fenster-${ansicht}`, `popup=yes,width=${b},height=${h}`)
  w?.focus?.()
}

export function FensterKnopf({ ansicht, className = '', kompakt = false }: { ansicht: string; className?: string; kompakt?: boolean }) {
  if (istFenster()) return null
  return (
    <button
      type="button"
      className={`ui-fenster-knopf ${className}`}
      onClick={() => oeffneFenster(ansicht)}
      title="In eigenem Fenster öffnen"
      aria-label="In eigenem Fenster öffnen"
      data-testid="fenster-loesen"
    >
      <ExternalLink className="h-4 w-4 shrink-0" aria-hidden="true" />
      {!kompakt && <span>In eigenem Fenster öffnen</span>}
    </button>
  )
}

/** Rahmen einer gelösten Ansicht: schlanke Kopfzeile mit Titel und Verbindungsstatus, sonst nur der Inhalt. */
export function FensterRahmen({ titel, kopf, children }: { titel: string; kopf?: React.ReactNode; children: React.ReactNode }) {
  React.useEffect(() => {
    const alt = document.title
    document.title = `${titel} – Pilot-Hub`
    return () => { document.title = alt }
  }, [titel])
  return (
    <div className="ui-fenster" data-testid="fenster-rahmen">
      <header className="ui-fenster-kopf">
        <h1 className="ui-fenster-titel">{titel}</h1>
        {kopf}
        <div className="ml-auto flex items-center gap-2"><StatusBar /></div>
      </header>
      <StaleBanner />
      <main className="ui-fenster-inhalt">{children}</main>
    </div>
  )
}
